import { Component, computed, inject, input } from '@angular/core';
import { ButtonComponent } from '../../button/button.component';
import { LayoutService } from '../../../../core/services/layout.service';
import { HeadingComponent } from '../../typography/heading/heading.component';

import { FleetService } from '../../../../core/services/fleet.service';

import { BadgeComponent } from '../../badge/badge.component';
import { PageContextService } from '../../../../core/services/page-context.service';
import { NotificationBellComponent } from '../../notifications/notification-bell/notification-bell.component';

@Component({
  selector: 'app-main-header',
  standalone: true,
  imports: [
    ButtonComponent,
    HeadingComponent,
    BadgeComponent,
    NotificationBellComponent],
  templateUrl: './main-header.component.html',
  styleUrl: './main-header.component.css',
})
export class MainHeaderComponent {
  layoutService = inject(LayoutService);
  private fleetService = inject(FleetService);
  private pageContextService = inject(PageContextService);
  readonly pageTitle = input<string | null>(null);
  protected fleetName = computed(() => {
    return this.fleetService.currentCompanySignal()?.legalName || 'My Fleet';
  });
  protected isSmallDesktopOrBelow = this.layoutService.isSmallDesktopOrBelow;
  protected isTabletOrBelow = this.layoutService.isTabletOrBelow;
  protected isMobile = this.layoutService.isMobile;

  protected fleetNameInitials = computed(() => {
    const fleetName = this.fleetService.currentCompanySignal()?.legalName || '';
    return fleetName
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase())
      .join('')
      .slice(0, 2); // Limit to 2 initials
  });
  protected statusBadge = this.pageContextService.statusBadge;
}
